export default __webpack_public_path__ + "static/media/MaintenanceMenu-Dark.642add12.svg";